import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Main as Container } from 'Components/Main';
import { VendorList } from 'Components/vendors/VendorList';
import { VendorForm } from 'Components/vendors/VendorForm';
import { useAuthTenant } from 'store/auth';
import { PageHeader } from 'Components/ui';

const BLUE = 'var(--vo-celeste)';

const AddBtn = styled.button`
  height: 40px;
  padding: 0 18px;
  background: ${BLUE};
  color: white;
  border: none;
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { background: var(--vo-cobalto); }
`;

const FormWrapper = styled.div`
  max-width: 760px;
`;

export const VendorsPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const { t } = useTranslation(['vendor', 'common']);
  const selectedTenant = useSelector(useAuthTenant);

  const handleOpenForm = (vendor = null) => {
    setSelectedVendor(vendor);
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedVendor(null);
  };

  if (isFormOpen) {
    return (
      <Container>
        <PageHeader
          title={selectedVendor ? t('vendor:form.title.edit') : t('vendor:form.title.add')}
          segments={[
            { label: t('common:breadcrumbs.thirdPartyRiskManagement') },
            { label: t('vendor:form.breadcrumb.vendors') },
            { label: selectedVendor ? t('vendor:form.breadcrumb.edit') : t('vendor:form.breadcrumb.new') },
          ]}
        />

        <FormWrapper>
          <VendorForm
            vendor={selectedVendor}
            onSuccess={handleCloseForm}
            onCancel={handleCloseForm}
          />
        </FormWrapper>
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader
        title={t('vendor:list.title')}
        segments={[
          { label: t('common:breadcrumbs.thirdPartyRiskManagement') },
          { label: t('vendor:form.breadcrumb.vendors') },
        ]}
        actions={
          <AddBtn onClick={() => handleOpenForm()}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            {t('vendor:form.title.add')}
          </AddBtn>
        }
      />

      <VendorList
        onEdit={handleOpenForm}
        tenant={selectedTenant?.slug}
      />
    </Container>
  );
};
